import customAxios from "../serverCall";

const getMarketplaceList = async (body) => {
  const response = await customAxios.post(
    `/admin/marketplace-verification/list`,
    body
  );

  return response;
};

const updateMarketplaceStatus = async (body) => {
  const response = await customAxios.post(
    `/admin/marketplace-verification/manage`,
    body
  );

  return response;
};

const MarketplaceService = {
  getMarketplaceList,
  updateMarketplaceStatus,
};

export default MarketplaceService; 